<template>
    <div class="complex">
        <div class="complex-desktop">
            <template v-if="viewMode == 'list'">
                <lgn-input class="complex-user-search" placeholder="搜尋" v-model="searchText" 
                :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchUsers"
                @keyup.enter.native="searchUsers('search')"></lgn-input>
                <div class="complex-tag-group">
                    <button type="button" class="complex-tag-group-item" :class="{'is-active' : listMode == 'total'}" @click="searchUsers('total')">全部 {{userGroup.total.length}}</button>
                    <button type="button" class="complex-tag-group-item" :class="{'is-active' : listMode == 'is_admin'}" @click="searchUsers('is_admin')">管理 {{userGroup.is_admin.length}}</button>
                    <button type="button" class="complex-tag-group-item" :class="{'is-active' : listMode == 'is_partner'}" @click="searchUsers('is_partner')">夥伴 {{userGroup.is_partner.length}}</button>
                    <button type="button" class="complex-tag-group-item" :class="{'is-active' : listMode == 'is_agent'}" @click="searchUsers('is_agent')">代理 {{userGroup.is_agent.length}}</button>
                    <button type="button" class="complex-tag-group-item" :class="{'is-active' : listMode == 'is_siteowner'}" @click="searchUsers('is_siteowner')">企業 {{userGroup.is_siteowner.length}}</button>
                    <button type="button" class="complex-tag-group-item" :class="{'is-active' : listMode == 'is_free_siteowner'}" @click="searchUsers('is_free_siteowner')">業者 {{userGroup.is_free_siteowner.length}}</button>
                </div>
                <div class="complex-user-list">
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-lock"></div>
                            <div class="paca-table__header-item item-column column-nickname">暱稱 ({{userList.length}})</div>
                            <div class="paca-table__header-item item-column column-identity">權限</div>
                            <div class="paca-table__header-item item-column column-email">信箱</div>
                            <div class="paca-table__header-item item-column column-login">最後登入</div>
                        </div>
                        <div class="paca-table__body">
                            <div class="paca-table__body-col" v-for="(item, index) in userList" :key="index">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-lock">
                                        <button class="column-lock-icon" :class="item.is_locked==0?'unlock el-icon-unlock':'lock paca-icon-lock'" @click="lockUser(index)"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-nickname">
                                        <button class="column-nickname-button" type="button" @click="viewUserDetail(item)">{{item.nickname}}</button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-identity">{{identityTranslation[item.identity]}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-email">{{item.email}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-login">{{item.last_login}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="viewMode == 'detail'">
                <div class="complex-back">
                    <button class="complex-back-button" @click="backUserList()"><i class="el-icon-back"></i> 返回</button>
                </div>
                <div class="complex-user-detail">
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶編號</div>
                        <div class="complex-user-detail-item-value">{{detailItem.id}}</div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶暱稱</div>
                        <div class="complex-user-detail-item-value">
                            <el-input v-model="detailItem.nickname" @change="putAdminUserInfo()"></el-input>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶權限</div>
                        <div class="complex-user-detail-item-value">
                            <el-select v-model="detailItem.identity" @change="changeUserIdentity(detailItem, detailItem.identity)">
                                <el-option v-for="(identityItem, identityIndex) in identityList" :key="identityIndex"
                                :label="identityItem.key" :value="identityItem.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶信箱</div>
                        <div class="complex-user-detail-item-value">
                            <el-input v-model="detailItem.email" @change="putAdminUserInfo()"></el-input>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶密碼</div>
                        <div class="complex-user-detail-item-value">
                            <button class="complex-user-detail-item-value-button" type="button" @click="openPasswordDialog(detailItem)">更改密碼</button>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">建立時間</div>
                        <div class="complex-user-detail-item-value">{{detailItem.created_at}}</div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">最後登入</div>
                        <div class="complex-user-detail-item-value">{{detailItem.last_login}}</div>
                    </div>
                </div>
                <div class="complex-user-token" :key="tokenKey">
                    <div class="paca-group">
                        <div class="paca-group-list list-token" :class="{'is-active': detailTokenOpen}">
                            <div class="paca-group-list__header" @click="itemCollapse('token')" >
                                <i class="paca-group-list__header-icon"></i>
                                <span class="paca-group-list__header-text">
                                    <span class="paca-group-list__header-text-nickname">憑證</span>
                                    <span class="paca-group-list__header-text-length">{{tokenGroup[detailItem.nickname] ? tokenGroup[detailItem.nickname].length : 0}}</span>
                                </span>
                            </div>
                            <div class="paca-group-list__content" v-if="tokenGroup[sourceDetailItem.nickname]">
                                <div class="paca-table">
                                    <div class="paca-table__header">
                                        <div class="paca-table__header-item item-column column-lock"></div>
                                        <div class="paca-table__header-item item-column column-name">名稱</div>
                                        <div class="paca-table__header-item item-column column-accounting">帳務</div>
                                        <div class="paca-table__header-item item-column column-gate">場務</div>
                                        <div class="paca-table__header-item item-column column-cars">車籍</div>
                                        <div class="paca-table__header-item item-column column-import">匯入</div>
                                        <div class="paca-table__header-item item-column column-config">設定</div>
                                        <div class="paca-table__header-item item-column column-create">建立時間</div>
                                        <div class="paca-table__header-item item-column column-last-seen">最後使用</div>
                                        <div class="paca-table__header-item item-column column-action"></div>
                                    </div>
                                    <div class="paca-table__body" v-if="tokenGroup[sourceDetailItem.nickname].length > 0">
                                        <div class="paca-table__body-col" v-for="(secItem,secIndex) in tokenGroup[sourceDetailItem.nickname]" :key="secIndex">
                                            <div class="paca-table__body-col-list">
                                                <div class="paca-table__body-col-list-item item-column column-lock">
                                                    <button class="column-lock-icon" :class="secItem.is_locked==0?'unlock el-icon-unlock':'lock paca-icon-lock'" @click="lockToken(secIndex)"></button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-name overflow-text">{{secItem.name}}</div>
                                                <div class="paca-table__body-col-list-item item-column column-accounting" >
                                                    <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_accounting.enable==1)}" @click="changeTokenValue(secIndex,'priv_accounting')"></button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-gate" >
                                                    <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_gate.enable==1)}" @click="changeTokenValue(secIndex,'priv_gate')"></button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-cars" >
                                                    <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_car_edit.enable==1)}" @click="changeTokenValue(secIndex,'priv_car_edit')"></button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-import">
                                                    <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_car_import.enable==1)}"  @click="changeTokenValue(secIndex,'priv_car_import')"></button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-config" >
                                                    <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_config.enable==1)}" @click="changeTokenValue(secIndex,'priv_config')"></button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-create">{{secItem.created_at}}</div>
                                                <div class="paca-table__body-col-list-item item-column column-last-seen">{{secItem.lastseen_at}}</div>
                                                <div class="paca-table__body-col-list-item item-column column-action">
                                                    <button class="column-action-button el-icon-document" @click="openTokenInfoDialog(secItem)"></button>
                                                    <button class="column-action-button el-icon-delete" @click="deleteToken(secItem.name, secItem.email, index, secIndex)"></button>
                                                </div>         
                                            </div>
                                        </div>
                                    </div>
                                    <div class="paca-table__empty" v-else>暫無資料</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="complex-user-site">
                    <div class="paca-group">
                        <div class="paca-group-list list-site" :class="{'is-active': detailSiteOpen}">
                            <div class="paca-group-list__header" @click="itemCollapse('site')" >
                                <i class="paca-group-list__header-icon"></i>
                                <span class="paca-group-list__header-text">
                                    <span class="paca-group-list__header-text-nickname">場站</span>
                                    <span class="paca-group-list__header-text-length">{{siteGroup[sourceDetailItem.nickname] ? siteGroup[sourceDetailItem.nickname].length : 0}}</span>
                                </span>
                            </div>
                            <div class="paca-group-list__content" v-if="siteGroup[sourceDetailItem.nickname]">
                                <div class="paca-table">
                                    <div class="paca-table__header">
                                        <div class="paca-table__header-item item-column column-name">場站名稱</div>
                                        <div class="paca-table__header-item item-column column-site">場站代碼</div>
                                        <div class="paca-table__header-item item-column column-vendor">遠通代碼</div>
                                        <div class="paca-table__header-item item-column column-join">加入時間</div>
                                    </div>
                                    <div class="paca-table__body" v-if="siteGroup[sourceDetailItem.nickname].length > 0">
                                        <div class="paca-table__body-col" v-for="(secItem,secIndex) in siteGroup[sourceDetailItem.nickname]" :key="secIndex">
                                            <div class="paca-table__body-col-list">
                                                <div class="paca-table__body-col-list-item item-column column-name">{{secItem.name}}</div>
                                                <div class="paca-table__body-col-list-item item-column column-site">
                                                    <button type="button" class="column-site-button" @click="gotoSearchReg(secItem.site)">{{secItem.site}}</button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-vendor">{{secItem.vendor}}</div>
                                                <div class="paca-table__body-col-list-item item-column column-join">{{secItem.siteowner_created_at}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="paca-table__empty" v-else>暫無資料</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="complex-user-service" :key="serviceKey">
                    <div class="paca-group">
                        <div class="paca-group-list list-site" :class="{'is-active': detailServiceOpen}">
                            <div class="paca-group-list__header" @click="itemCollapse('service')" >
                                <i class="paca-group-list__header-icon"></i>
                                <span class="paca-group-list__header-text">
                                    <span class="paca-group-list__header-text-nickname">服務</span>
                                    <span class="paca-group-list__header-text-length">{{detailItem.user_services.length}}</span>
                                    
                                </span>
                            </div>
                            <div class="paca-group-list__content">
                                <div class="paca-table">
                                    <div class="paca-table__header">
                                        <div class="paca-table__header-item item-column column-service">項目</div>
                                        <div class="paca-table__header-item item-column column-exist">擁有</div>
                                        <div class="paca-table__header-item item-column column-enable">啟用</div>
                                    </div>
                                    <div class="paca-table__body">
                                        <div class="paca-table__body-col" v-for="(item, index) in serviceList" :key="index">
                                            <div class="paca-table__body-col-list">
                                                <div class="paca-table__body-col-list-item item-column column-service">{{item.title}}</div>
                                                <div class="paca-table__body-col-list-item item-column column-exist">
                                                    <button type="button" class="checkbox-button" :class="{'is-check': detailItem[item.name].exist == 1}" @click="changeServiceExist(item)"></button>
                                                </div>
                                                <div class="paca-table__body-col-list-item item-column column-enable">
                                                    <el-switch :disabled="detailItem[item.name].exist == 0" @change="putService(item)" v-model="detailItem[item.name].enable" :active-value="1" :inactive-value="0" active-color="#9B90C2" inactive-color="#dedfe0"></el-switch>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="complex-mobile" :class="{'detail-page': viewMode == 'detail'}">
            <div class="complex-search-area">
                <lgn-input class="complex-user-search" placeholder="搜尋" v-model="searchText" 
                :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchUsers"
                @keyup.enter.native="searchUsers('search')"></lgn-input>
            </div>
            <div class="complex-group-area">
                <template v-if="viewMode == 'list'">
                    <button type="button" @click="searchUsers('total')" class="complex-group-area-item" :class="{'is-active': listMode == 'total'}">
                        <div class="complex-group-area-item-img el-icon-folder">
                            <div class="complex-group-area-item-img-length">{{userGroup.total.length}}</div>
                        </div>
                        <div class="complex-group-area-item-label">全部</div>
                    </button>
                    <button type="button" @click="searchUsers('is_admin')" class="complex-group-area-item" :class="{'is-active': listMode == 'is_admin'}">
                        <div class="complex-group-area-item-img el-icon-medal">
                            <div class="complex-group-area-item-img-length">{{userGroup.is_admin.length}}</div>
                        </div>
                        <div class="complex-group-area-item-label">管理</div>
                    </button>
                    <button type="button" @click="searchUsers('is_partner')" class="complex-group-area-item" :class="{'is-active': listMode == 'is_partner'}">
                        <div class="complex-group-area-item-img paca-icon-partner">
                            <div class="complex-group-area-item-img-length">{{userGroup.is_partner.length}}</div>
                        </div>
                        <div class="complex-group-area-item-label">夥伴</div>
                    </button>
                    <button type="button" @click="searchUsers('is_agent')" class="complex-group-area-item" :class="{'is-active': listMode == 'is_agent'}">
                        <div class="complex-group-area-item-img el-icon-suitcase-1">
                            <div class="complex-group-area-item-img-length">{{userGroup.is_agent.length}}</div>
                        </div>
                        <div class="complex-group-area-item-label">代理</div>
                    </button>
                    <button type="button" @click="searchUsers('is_siteowner')" class="complex-group-area-item" :class="{'is-active': listMode == 'is_siteowner'}">
                        <div class="complex-group-area-item-img el-icon-office-building">
                            <div class="complex-group-area-item-img-length">{{userGroup.is_siteowner.length}}</div>
                        </div>
                        <div class="complex-group-area-item-label">企業</div>
                    </button>
                    <button type="button" @click="searchUsers('is_free_siteowner')" class="complex-group-area-item" :class="{'is-active': listMode == 'is_free_siteowner'}">
                        <div class="complex-group-area-item-img paca-icon-custom">
                            <div class="complex-group-area-item-img-length">{{userGroup.is_free_siteowner.length}}</div>
                        </div>
                        <div class="complex-group-area-item-label">業者</div>
                    </button>
                </template>
                <template v-if="viewMode == 'detail'">
                    <button type="button" @click="changeDetailMode('detail')" class="complex-group-area-item" :class="{'is-active': detailMode == 'detail'}">
                        <div class="complex-group-area-item-img el-icon-user">
                        </div>
                        <div class="complex-group-area-item-label">用戶</div>
                    </button>
                    <button type="button" @click="changeDetailMode('token')" class="complex-group-area-item" :class="{'is-active': detailMode == 'token'}">
                        <div class="complex-group-area-item-img el-icon-files">
                            <div class="complex-group-area-item-img-length">{{tokenGroup[detailItem.nickname] ? tokenGroup[detailItem.nickname].length : 0}}</div>
                        </div>
                        <div class="complex-group-area-item-label">憑證</div>
                    </button>
                    <button type="button" @click="changeDetailMode('site')" class="complex-group-area-item" :class="{'is-active': detailMode == 'site'}">
                        <div class="complex-group-area-item-img el-icon-place">
                            <div class="complex-group-area-item-img-length">{{siteGroup[sourceDetailItem.nickname] ? siteGroup[sourceDetailItem.nickname].length : 0}}</div>
                        </div>
                        <div class="complex-group-area-item-label">場站</div>
                    </button>
                    <button type="button" @click="changeDetailMode('service')" class="complex-group-area-item" :class="{'is-active': detailMode == 'service'}">
                        <div class="complex-group-area-item-img el-icon-help">
                            <div class="complex-group-area-item-img-length">{{detailItem.user_services.length}}</div>
                        </div>
                        <div class="complex-group-area-item-label">服務</div>
                    </button>
                </template>
            </div>
            <template v-if="viewMode == 'list'">
                <div class="complex-user-list">
                    <div class="paca-table">
                        <div class="paca-table__body">
                            <div class="paca-table__body-col" v-for="(item, index) in userList" :key="`mobile_${index}`">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-lock">
                                        <button class="column-lock-icon" :class="item.is_locked==0?'unlock el-icon-unlock':'lock paca-icon-lock'" @click="lockUser(index)"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-nickname">
                                        <button class="column-nickname-button" type="button" @click="viewUserDetail(item)">{{item.nickname}}</button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-identity">{{identityTranslation[item.identity]}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-email">{{item.email}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-login">{{item.last_login}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="viewMode == 'detail'">
                <div class="complex-user-detail" v-if="detailMode == 'detail'">
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶編號</div>
                        <div class="complex-user-detail-item-value">{{detailItem.id}}</div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶暱稱</div>
                        <div class="complex-user-detail-item-value">
                            <el-input v-model="detailItem.nickname" @change="putAdminUserInfo()"></el-input>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶權限</div>
                        <div class="complex-user-detail-item-value">
                            <el-select v-model="detailItem.identity" @change="changeUserIdentity(detailItem, detailItem.identity)">
                                <el-option v-for="(identityItem, identityIndex) in identityList" :key="identityIndex"
                                :label="identityItem.key" :value="identityItem.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶信箱</div>
                        <div class="complex-user-detail-item-value">
                            <el-input v-model="detailItem.email" @change="putAdminUserInfo()"></el-input>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">用戶密碼</div>
                        <div class="complex-user-detail-item-value">
                            <button class="complex-user-detail-item-value-button" type="button" @click="openPasswordDialog(detailItem)">更改密碼</button>
                        </div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">建立時間</div>
                        <div class="complex-user-detail-item-value">{{detailItem.created_at}}</div>
                    </div>
                    <div class="complex-user-detail-item">
                        <div class="complex-user-detail-item-label">最後登入</div>
                        <div class="complex-user-detail-item-value">{{detailItem.last_login}}</div>
                    </div>
                </div>
                <div class="complex-user-token" :key="tokenKey" v-if="detailMode == 'token'">
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-lock"></div>
                            <div class="paca-table__header-item item-column column-name">名稱</div>
                            <div class="paca-table__header-item item-column column-accounting">帳務</div>
                            <div class="paca-table__header-item item-column column-gate">場務</div>
                            <div class="paca-table__header-item item-column column-cars">車籍</div>
                            <div class="paca-table__header-item item-column column-import">匯入</div>
                            <div class="paca-table__header-item item-column column-config">設定</div>
                            <div class="paca-table__header-item item-column column-create">建立時間</div>
                            <div class="paca-table__header-item item-column column-last-seen">最後使用</div>
                            <div class="paca-table__header-item item-column column-action"></div>
                        </div>
                        <div class="paca-table__body" v-if="tokenGroup[sourceDetailItem.nickname] && tokenGroup[sourceDetailItem.nickname].length > 0">
                            <div class="paca-table__body-col" v-for="(secItem,secIndex) in tokenGroup[sourceDetailItem.nickname]" :key="secIndex">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-lock">
                                        <button class="column-lock-icon" :class="secItem.is_locked==0?'unlock el-icon-unlock':'lock paca-icon-lock'" @click="lockToken(secIndex)"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-name overflow-text">{{secItem.name}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-accounting" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_accounting.enable==1)}" @click="changeTokenValue(secIndex,'priv_accounting')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-gate" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_gate.enable==1)}" @click="changeTokenValue(secIndex,'priv_gate')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-cars" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_car_edit.enable==1)}" @click="changeTokenValue(secIndex,'priv_car_edit')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-import">
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_car_import.enable==1)}"  @click="changeTokenValue(secIndex,'priv_car_import')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-config" >
                                        <button class="checkbox-button" :class="{'is-check':(secItem.cbox_permission.priv_config.enable==1)}" @click="changeTokenValue(secIndex,'priv_config')"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-create">{{secItem.created_at}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-last-seen">{{secItem.lastseen_at}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-action">
                                        <button class="column-action-button el-icon-document" @click="openTokenInfoDialog(secItem)"></button>
                                        <button class="column-action-button el-icon-delete" @click="deleteToken(secItem.name, secItem.email, index, secIndex)"></button>
                                    </div>         
                                </div>
                            </div>
                        </div>
                        <div class="paca-table__empty" v-else>暫無資料</div>
                    </div>
                </div>
                <div class="complex-user-site" v-if="detailMode == 'site'">
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-name">場站名稱</div>
                            <div class="paca-table__header-item item-column column-site">場站代碼</div>
                            <div class="paca-table__header-item item-column column-vendor">遠通代碼</div>
                            <div class="paca-table__header-item item-column column-join">加入時間</div>
                        </div>
                        <div class="paca-table__body" v-if="siteGroup[sourceDetailItem.nickname] && siteGroup[sourceDetailItem.nickname].length > 0">
                            <div class="paca-table__body-col" v-for="(secItem,secIndex) in siteGroup[sourceDetailItem.nickname]" :key="secIndex">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-name">{{secItem.name}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-site">
                                        <button type="button" class="column-site-button" @click="gotoSearchReg(secItem.site)">{{secItem.site}}</button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-vendor">{{secItem.vendor}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-join">{{secItem.siteowner_created_at}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="paca-table__empty" v-else>暫無資料</div>
                    </div>
                </div>
                <div class="complex-user-service" :key="serviceKey" v-if="detailMode == 'service'">
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-service">項目</div>
                            <div class="paca-table__header-item item-column column-exist">擁有</div>
                            <div class="paca-table__header-item item-column column-enable">啟用</div>
                        </div>
                        <div class="paca-table__body">
                            <div class="paca-table__body-col" v-for="(item, index) in serviceList" :key="index">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-service">{{item.title}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-exist">
                                        <button type="button" class="checkbox-button" :class="{'is-check': detailItem[item.name].exist == 1}" @click="changeServiceExist(item)"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-enable">
                                        <el-switch :disabled="detailItem[item.name].exist == 0" @change="putService(item)" v-model="detailItem[item.name].enable" :active-value="1" :inactive-value="0" active-color="#9B90C2" inactive-color="#dedfe0"></el-switch>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" class="complex-detail-back" @click="backUserList()"><i class="el-icon-back"></i> 回上一頁</button>
            </template>
        </div>
        <el-dialog class="complex__info-dialog" :visible.sync="isInfoDialogOpen" v-if="userInfoDialogInfo">
            <div slot="title">{{userInfoDialogInfo.nickname}}</div>
            <div class="complex__info-dialog__body">
                <div class="complex__info-dialog__body-item">
                    <div class="complex__info-dialog__body-item-label">用戶編號</div>
                    <div class="complex__info-dialog__body-item-value">{{userInfoDialogInfo.id}}</div>
                </div>
                <div class="complex__info-dialog__body-item">
                    <div class="complex__info-dialog__body-item-label">用戶信箱</div>
                    <div class="complex__info-dialog__body-item-value">{{userInfoDialogInfo.email}}</div>
                </div>
                <div class="complex__info-dialog__body-item">
                    <div class="complex__info-dialog__body-item-label">建立時間</div>
                    <div class="complex__info-dialog__body-item-value">{{userInfoDialogInfo.created_at}}</div>
                </div>
                <div class="complex__info-dialog__body-item">
                    <div class="complex__info-dialog__body-item-label">最後登入</div>
                    <div class="complex__info-dialog__body-item-value">{{userInfoDialogInfo.last_login}}</div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="complex__info-dialog__footer-button main-button" @click="CloseUserInfoDialog">確認</button>
            </div>
        </el-dialog>
        <el-dialog class="admin-token-dialog" :visible.sync="isTokenDialogOpen" v-if="tokenDialogInfo">
            <div slot="title">{{tokenDialogInfo.name}}</div>
            <div class="admin-token-dialog__body">
                <div class="admin-token-dialog__body-item">
                    <div class="admin-token-dialog__body-item-label">建立時間</div>
                    <div class="admin-token-dialog__body-item-value">{{tokenDialogInfo.created_at}}</div>
                </div>
                <div class="admin-token-dialog__body-item">
                    <div class="admin-token-dialog__body-item-label">最後使用</div>
                    <div class="admin-token-dialog__body-item-value">{{tokenDialogInfo.lastseen_at}}</div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="admin-token-dialog__footer-button main-button" @click="CloseTokenInfoDialog">確認</button>
            </div>
        </el-dialog>
        <el-dialog class="complex__edit-dialog" :visible.sync="isEditPasswordDialogOpen">
            <div class="complex__edit-dialog__header" slot="title">更改密碼</div>
            <div class="complex__edit-dialog__body">
                <form @submit.prevent @keyup.enter="putEditUserPassword(passwordForm)">
                    <lgn-form-item label-position="left">
                        <div slot="label">暱稱</div>
                        <div slot="input" class="complex__edit-dialog__body-edit-nickname">{{passwordForm.nickname}}</div>
                    </lgn-form-item>
                    <lgn-form-item label-position="left">
                        <div slot="label">新密碼</div>
                        <lgn-input slot="input" class="complex__edit-dialog__body-edit-name" v-model="passwordForm.password"></lgn-input>
                    </lgn-form-item>
                </form>
            </div>
            <div class="complex__edit-diaog__footer" slot="footer">
                <el-button class="complex__edit-dialog__footer-submit-button main-button" @click="putEditUserPassword(passwordForm)">送出</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import itemTrim from '@/script/trim/trim.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
import {getFullTime, timeFormatStandardToString} from "@/script/time/time.js"
export default {
    name: "complex",
    data(){
        return {
            searchText: '',
            userGroup: {
                total: [],
                is_admin: [],
                is_partner: [],
                is_free_siteowner: [],
                is_siteowner: [],
                is_agent: []
            },
            userList: [],
            identityTranslation: {
                is_admin: "管理",
                is_partner: "夥伴",
                is_agent: "代理",
                is_siteowner: "企業",
                is_free_siteowner: "業者"
            },
            identityList: [
                {key: '管理', value: 'is_admin'},
                {key: '夥伴', value: 'is_partner'},
                {key: '代理', value: 'is_agent'},
                {key: '企業', value: 'is_siteowner'},
                {key: '業者', value: 'is_free_siteowner'}
            ],
            tokenGroup: {},
            siteGroup: {},
            viewMode: 'list',
            listMode: 'total',
            detailMode: 'detail',
            sourceDetailItem: {},
            detailItem: {},
            userInfoDialogInfo: null,
            isInfoDialogOpen: false,
            tokenDialogInfo: null,
            isTokenDialogOpen: false,
            isEditPasswordDialogOpen: false,
            passwordForm: {},
            tokenKey: 1,
            serviceKey: -1,
            detailTokenOpen: false,
            detailSiteOpen: false,
            detailServiceOpen: false,
            serviceList: [],
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        itemCollapse(key){
            if(key == 'token'){
                this.detailTokenOpen = !this.detailTokenOpen;
            } else if(key == 'site'){
                this.detailSiteOpen = !this.detailSiteOpen;
            } else if(key == 'service'){
                this.detailServiceOpen = !this.detailServiceOpen;
            }
        },
        async getUsers(){
            let res = await api.getAdminUserList();
            if(!res.error_status){
                res.splice(res.findIndex(item => item.nickname == this.userInfo.nickname), 1);
                this.userGroup = {
                    total: [],
                    is_admin: [],
                    is_partner: [],
                    is_free_siteowner: [],
                    is_siteowner: [],
                    is_agent: []
                };
                res.forEach((item) => {
                    let createTime = null;
                    let lastLoginTime = null;
                    if(item.created_at){
                        createTime = getFullTime(new Date(item.created_at));
                    } else{
                        createTime = "無";
                    }
                    if(item.last_login){
                        lastLoginTime = getFullTime(new Date(timeFormatStandardToString(item.last_login)));
                    } else {
                        lastLoginTime = "無";
                    }
                    item.identity = null;
                    let identityList = ["is_admin", "is_partner", "is_agent", "is_siteowner", "is_free_siteowner"];
                    identityList.forEach(function(identity){
                        if(item[identity] == 1){
                            item.identity = identity;
                            this.userGroup[identity].push(item);
                        }
                    }.bind(this))
                    item.created_at = createTime;
                    item.last_login = lastLoginTime;
                    this.userGroup.total.push(item);
                })
                this.userList = this.userGroup.total;
            }else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        async getTokenList(){
            let res = await api.getAdminTokenList();
            if(!res.error_status){
                res.forEach(function(item){
                    item.result.forEach((secItem) => {
                        let createTime = null;
                        let lastSeenTime = null;
                        if(secItem.created_at){
                            createTime = getFullTime(new Date(secItem.created_at));
                        } else{
                            createTime = "無";
                        }
                        if(secItem.lastseen_at){
                            lastSeenTime = getFullTime(new Date(secItem.lastseen_at));
                        } else {
                            lastSeenTime = "無";
                        }
                        secItem.created_at = createTime;
                        secItem.lastseen_at = lastSeenTime;
                    })
                    this.tokenGroup[item.id] = item.result;
                }.bind(this))
            }
        },
        async getSiteList(){
            let res = await api.getAdminSiteOwnerList();
            if(!res.error_status){
                res.forEach(function(item){
                    item.sites_info.forEach(secItem => {
                        secItem.siteowner_created_at = getFullTime(new Date (timeFormatStandardToString(secItem.siteowner_created_at)));
                    })
                    this.siteGroup[item.nickname] = item.sites_info;
                }.bind(this))
            }
        },
        searchUsers(mode){
            this.listMode = mode;
            if(this.userGroup[mode]){
                this.userList = this.userGroup[mode];
            } else{
                this.userList = [];
                this.userGroup.total.forEach(function(item){
                    if(item.nickname.indexOf(this.searchText) != -1){
                        this.userList.push(item);
                    }
                }.bind(this))
            }
        },
        changeDetailMode(mode){
            this.detailMode = mode;
        },
        async lockUser(index){
            this.userList[index].is_locked = (this.userList[index].is_locked + 1) % 2;
            let res = null;
            if(this.userList[index].is_locked == 0){
                res = await api.putUserUnLock(this.userList[index].id);
            }else if(this.userList[index].is_locked==1){
                res = await api.putUserLock(this.userList[index].id);
            }
            if(!res.error_status){
            }
        },
        async lockToken(itemIndex){
            this.tokenGroup[this.detailItem.nickname][itemIndex].is_locked = (this.tokenGroup[this.detailItem.nickname][itemIndex].is_locked + 1) % 2;
            this.tokenKey += 1;
            if(this.tokenGroup[this.detailItem.nickname][itemIndex].is_locked == 0){
                await api.putAdminTokenUnLock(this.tokenGroup[this.detailItem.nickname][itemIndex].email);
            }else{
                await api.putAdminTokenLock(this.tokenGroup[this.detailItem.nickname][itemIndex].email);
            }
        },
        openUserInfoDialog(item){
            this.userInfoDialogInfo = JSON.parse(JSON.stringify(item));
            this.isInfoDialogOpen = true;
        },
        openTokenInfoDialog(item){
            this.tokenDialogInfo = JSON.parse(JSON.stringify(item));
            this.isTokenDialogOpen = true;
        },
        deleteToken(token_name, token_email, index, secItemIndex){
            this.$confirm(`即將刪除 ${token_name}`,"刪除權限", {
                confirmButtonText: "確認刪除",
                confirmButtonClass: "main-button",
                cancelButtonText: "取消",
                cancelButtonClass: "second-button",
                type: 'warning'
            }).then(async () => {
                let res = await api.deleteServiceToken(token_email);
                if(!res.error_status){
                    this.tokenList[index].result.splice(secItemIndex,1);
                    if(this.tokenList[index].result.length == 0){
                        this.tokenList.splice(index, 1);
                    }
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤!"
                    });
                }
            }).catch(() => {})
        },
        CloseUserInfoDialog(){
            this.isInfoDialogOpen = false;
        },
        CloseTokenInfoDialog(){
            this.isTokenDialogOpen = false;
        },
        backUserList(){
            this.viewMode = 'list'
            this.$store.commit({
                type: 'setFullPage',
                fullPage: false
            });
        },
        viewUserDetail(item){
            this.$store.commit({
                type: 'setFullPage',
                fullPage: true
            });
            this.viewMode = 'detail';
            this.serviceList.forEach(service => {
                let itemService = item.user_services.find(detailItem => detailItem.name == service.name);
                if(itemService){
                    item[service.name] = {
                        exist: 1,
                        enable: itemService.enable
                    }
                } else {
                    item[service.name] = {
                        exist: 0,
                        enable: 0
                    }
                }
            });
            this.sourceDetailItem = JSON.parse(JSON.stringify(item));
            this.detailItem = item;
            this.detailTokenOpen = false;
            this.detailSiteOpen = false;
        },
        changeUserIdentity(item,target){
            let identityList = ["is_admin", "is_partner", "is_agent", "is_siteowner", "is_free_siteowner"];
            identityList.forEach((identity) => {
                if(identity == target){
                    item[identity] = 1;
                    item.identity = identity;
                }else{
                    item[identity] = 0;
                }
            })
            this.saveUserAuthority(item, target);
        },
        async saveUserAuthority(item, target){
            let identityData = target.split('').slice(3).join('').split("_").join('');
            let id = item.id;
            let IdentityResult = await api.putUserIdentity(id, identityData);
            if(IdentityResult.error_status){
                this.$message.error({
                    showClose: true,
                    duration: 2500,
                    message: this.$t("common.error")
                })
            }
            if(!IdentityResult.error_status){
            }
        },
        openPasswordDialog(item){
            this.passwordForm = JSON.parse(JSON.stringify(item));
            let bigText = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
            let smallText = "abcdefghijklmnopqrstuvwxyz".split("");
            let numberText = "0123456789".split("");
            let code = "";
            let i = 0;
            for(i;i < 9; i++){
                if(i < 3){
                    code += bigText[parseInt(Math.random()*26+1) - 1];
                }else if(i < 6){
                    code += smallText[parseInt(Math.random()*26+1) - 1];
                }else{
                    code += numberText[parseInt(Math.random()*10+1) - 1];
                }
            }
            this.passwordForm.password = code;
            this.isEditPasswordDialogOpen = true;
        },
        async putAdminUserInfo(){
            let data = {
                "email": this.detailItem.email,
                "nickname": this.detailItem.nickname
            }
            if(data.email.trim().length == 0 || data.nickname.trim().length == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "信箱及暱稱不得為空!"
                })
                return false;
            }
            let res = await api.putAdminUserInfo(this.detailItem.id,itemTrim(data))
            if(!res.error_status){
                if(this.siteGroup[this.sourceDetailItem.nickname]){
                    this.siteGroup[this.detailItem.nickname] = JSON.parse(JSON.stringify(this.siteGroup[this.sourceDetailItem.nickname]));
                    delete this.siteGroup[this.sourceDetailItem.nickname];
                }
                if(this.tokenGroup[this.sourceDetailItem.nickname]){
                    this.tokenGroup[this.detailItem.nickname] = JSON.parse(JSON.stringify(this.tokenGroup[this.sourceDetailItem.nickname]));
                    delete this.tokenGroup[this.sourceDetailItem.nickname];
                }
                this.sourceDetailItem = JSON.parse(JSON.stringify(this.detailItem));
            }
        },
        async putEditUserPassword(item){
            let data = {
                email: item.email,
                nickname: item.nickname,
                password: item.password
            }
            if(data.password.trim().length == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "密碼不得為空!"
                })
                return false
            }
            let res = await api.putAdminChangeUserPassword(item.id, data);
            if(!res.error_status){
                this.isEditPasswordDialogOpen = false;
                this.$message.success({
                    duration: 2500,
                    showClose: true,
                    message: "修改密碼成功!"
                })
            }
        },
        changeTokenValue(itemIndex, itemName){
            this.tokenGroup[this.detailItem.nickname][itemIndex].cbox_permission[itemName].enable = (this.tokenGroup[this.detailItem.nickname][itemIndex].cbox_permission[itemName].enable + 1) % 2;
            this.tokenKey += 1;
            this.putAdminTokenListItem(itemIndex);
        },
        async putAdminTokenListItem(itemIndex){
            let id = this.tokenGroup[this.detailItem.nickname][itemIndex].email
            let data = {
                "token_name" : this.tokenGroup[this.detailItem.nickname][itemIndex].name,
                "token_permission" : [
                    {"name": "priv_accounting","enable": this.tokenGroup[this.detailItem.nickname][itemIndex].cbox_permission.priv_accounting.enable},
                    {"name": "priv_car_edit","enable": this.tokenGroup[this.detailItem.nickname][itemIndex].cbox_permission.priv_car_edit.enable},
                    {"name": "priv_car_import","enable": this.tokenGroup[this.detailItem.nickname][itemIndex].cbox_permission.priv_car_import.enable},
                    {"name": "priv_config","enable": this.tokenGroup[this.detailItem.nickname][itemIndex].cbox_permission.priv_config.enable},
                    {"name": "priv_gate","enable": this.tokenGroup[this.detailItem.nickname][itemIndex].cbox_permission.priv_gate.enable},
                ]
            };
            let res = await api.putAdminTokenListItem(id,data);
            if(!res.error_status){

            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        gotoSearchReg(site){
            this.$router.push({
                name: 'RegList',
                params: {
                    site: site
                }
            })
        },
        async getServiceList(){
            let res  = await api.getServiceList();
            if(!res.error_status){
                this.serviceList = res;
            }
        },
        async postServicePlan(service){
            let data = {
                user_id: this.detailItem.id,
                services_name: service.name,
                enable: 1
            }
            let res = await api.postServiceAdd(data);
            if(!res.error_status){
                this.detailItem[service.name] = {
                    exist: 1,
                    enable: 1
                };
                this.serviceKey -= 1;
                this.getUsers();
            }
        },
        async putService(service){
            let data = {
                user_id: this.detailItem.id,
                services_name: service.name,
                enable: this.detailItem[service.name].enable
            };
            let res = await api.putServicePlan(data);
            if(!res.error_status){
                this.serviceKey -= 1;
                this.getUsers();
            }
        },
        async deleteService(service){
            this.$confirm(`即將移除 ${this.detailItem.name} 之 ${service.title} 服務`,"移除服務", {
                confirmButtonText: "移除服務",
                confirmButtonClass: "main-button",
                cancelButtonText: "取消",
                cancelButtonClass: "second-button",
                type: 'warning'
            }).then(async () => {
                let data = {
                    user_id: this.detailItem.id,
                    services_name: service.name
                }
                let res = await api.deleteServicePlan(data);
                if(!res.error_status){
                    this.detailItem[service.name] = {
                        exist: 0,
                        enable: 0
                    };
                    this.serviceKey -= 1;
                    this.getUsers();
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤!"
                    });
                }
            }).catch(() => {})
        },
        changeServiceExist(service){
            if(this.detailItem[service.name].exist == 0){
                this.postServicePlan(service);
            } else {
                this.deleteService(service);
            }
        }

    },
    computed: {
        userInfo(){
            return this.$store.state.userInfo
        }
    },
    async activated(){
        if(this.$route.params.nickname || this.$route.params.email){
            this.viewMode = 'none';
        }
        if(this.viewMode == 'detail' && window.innerWidth <= 620){
            this.$store.commit({
                type: 'setFullPage',
                fullPage: true
            });
        }
        await this.getUsers();
        await this.getTokenList();
        await this.getSiteList();
        await this.getServiceList();
        if(this.$route.params.nickname){
            let user = this.userList.find(item => item.nickname == this.$route.params.nickname);
            this.serviceList.forEach(service => {
                let itemService = user.user_services.find(detailItem => detailItem.name == service.name);
                if(itemService){
                    user[service.name] = {
                        exist: 1,
                        enable: itemService.enable
                    }
                } else {
                    user[service.name] = {
                        exist: 0,
                        enable: 0
                    }
                }
            });
            this.sourceDetailItem = JSON.parse(JSON.stringify(user));
            this.detailItem = user;
            this.viewMode = 'detail';
            this.detailTokenOpen = false;
            this.detailSiteOpen = false;
        } else if(this.$route.params.email){
            let user = this.userList.find(item => item.email == this.$route.params.email);
            this.serviceList.forEach(service => {
                let itemService = user.user_services.find(detailItem => detailItem.name == service.name);
                if(itemService){
                    user[service.name] = {
                        exist: 1,
                        enable: itemService.enable
                    }
                } else {
                    user[service.name] = {
                        exist: 0,
                        enable: 0
                    }
                }
            });
            this.sourceDetailItem = JSON.parse(JSON.stringify(user));
            this.detailItem = user;
            this.viewMode = 'detail';
            this.detailTokenOpen = false;
            this.detailSiteOpen = false;
        }
    },
    deactivated(){
          this.$store.commit({
            type: 'setFullPage',
            fullPage: false
        });
    }
}
</script>